import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import ReactGA from "react-ga";
// import ReactGA from 'react-ga4';
import { createTheme, ThemeProvider } from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Create theme
const theme = createTheme({
  palette: {
    tab: {
      // main: "#AE2129",
      main: "#df4715"
    },
  },
});

//Initialize GA4
// ReactGA.initialize("G-3SB2B2QB4K");
// ReactGA.initialize("G-VQYSKBB1TP");

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// const SendAnalytics = () => {
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//   });
// };

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(SendAnalytics);
